import { getToken, setToken, removeToken } from '@/utils/auth'
import { login } from '@/api/user'
// 状态
const state = {
  token: getToken()
  // 设置token初始状态
}
// 修改状态
const mutations = {
  // 设置token
  setToken(state, tokenanduserinformation) {
    state.token = tokenanduserinformation.token
    setToken(tokenanduserinformation)
  },
  removeToken(state) {
    state.token = null // 删除vuex的token
    removeToken()
  }
}
const actions = {
  async login(context, data) {
    // 调用api接口
    const tokenanduserinformation = await login(data) // 拿到token
    context.commit('setToken', tokenanduserinformation) // 设置token
    // 拿到token说明登录成功
    // setTimeStamp() // 设置当前的时间戳
  }
}
// // 执行异步
// const actions = {
//   // 定义login action  也需要参数 调用action时 传递过来的参数
//   async login(context, data) {
//     console.log(data)
//     const result = await login(data) // 实际上就是一个promise  result就是执行的结果
//     // axios默认给数据加了一层data
//     if (result.data.success) {
//       // 表示登录接口调用成功 也就是意味着你的用户名和密码是正确的
//       // 现在有用户token
//       // actions 修改state 必须通过mutations
//       context.commit('setToken', result.data.data)
//     }
//   }
// }namespaced
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
